import React, { useEffect, useState } from "react";
import { Row, Col, Button, Segmented } from "antd";
import styled from "styled-components";
import { ReactComponent as Dateicon } from "../../../assets/icons/Vector.svg";
import { useHistory } from "react-router-dom";
import { StyledTable } from "atoms/Table";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import moment from "moment";
import { connect, useSelector } from "react-redux";
import {
  getMinePerformanceList,
  getMyTeamPerformanceResponseViewList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { Heatmap } from "@ant-design/plots";
import PerformanceMatrix from "./PerformanceMatrix";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useFetch } from "hooks/useFetch";
import queryKeys from "common/queryKey";
import { CropLandscapeOutlined } from "@mui/icons-material";
const Customstyle = styled.div`
  .title {
    color: #636980;
    cursor: pointer;
  }
  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .text {
    font-size: 16px;
    font-weight: 400;
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 78%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 54px;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  }
  .footer-button {
    width: 100px;
    height: 35px;
    font-size: 16px;
    border-radius: 8px;
  }
  .parent-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .averagescore {
    width: max-content;
    height: 35px;
    border-radius: 8px;
    padding: 0px 10px;
    padding-top: 5px;
    color: #636980;
    background-color: #f4f4f4;
    display: flex;
    justify-content: flex-end;
  }
  .score {
    font-weight: 500;
  }
  .matrix {
    height: 226px;
  }
  .matrixright {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 400px;
    color: #636980;
    line-height: 10.26px;
  }
  .recommendtext {
    color: #636980;
  }
  .count {
    color: black;
  }
  .appraiser {
    display: flex;
    gap: 300px;
  }
  .final {
    margin-top: -5px;
  }
`;
const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 40px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #c2fae5 !important;
    color: black;
  }
`;

function Viewcompleted({ userList, userInfo }) {
  const history = useHistory();
  const { id } = useParams();
  const [completedsegment, setCompletedSegment] = useState([]);
  const [appraisalIndex, setAppraisalIndex] = useState(1);

  const minePerformanceList = useSelector(getMinePerformanceList);
  let filteredData =
    minePerformanceList?.find((item) => item?.contractid?.toString() === id) ||
    [];

  let apraiseemailid = filteredData.apraiseemailid;
  let appraiseeRoletype = filteredData.appraiseeroletype;

  const appraisalInformation = appraiseeRoletype.map((role) => ({
    roletype: role,
    appraiseeMailid: apraiseemailid,
  }));

  const [selectedSegment, setSelectedSegment] = useState(
    appraisalInformation?.[0]?.roletype || null
  );
  const handleSegmentChange = (value) => {
    const index = appraisalInformation.findIndex(
      (item) => item.roletype === value
    );

    setSelectedSegment(value);
    setAppraisalIndex(index + 1);
    setCompletedSegment((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index - 1];
      }
      return prev;
    });
  };

  const columns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What went well/Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "What can be improved / Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      render: (_, record) => {
        return record?.selfscore || record?.selfScore || "-";
      },
    },
    {
      title: "Appraiser’s Remark",
      dataIndex: "appraiserremarks",
      key: "appraiserremarks",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Appraiser’s Score",
      dataIndex: "appraiserscore",
      key: "appraiserscore",
      render: (text) => {
        return text || "-";
      },
    },
  ];

  const columns1 = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Major achievement",
      dataIndex: "whatwentwellmajorachivement",
      key: "whatwentwellmajorachivement",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Challenges",
      dataIndex: "whatdidnotgowellchallenges",
      key: "whatdidnotgowellchallenges",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Self Score",
      dataIndex: "selfscore",
      key: "selfscore",
      render: (_, record) => {
        return record?.selfscore || record?.selfScore || "-";
      },
    },
    {
      title: "Appraiser’s Remark",
      dataIndex: "appraiserremarks",
      key: "appraiserremarks",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Appraiser’s Score",
      dataIndex: "appraiserscore",
      key: "appraiserscore",
      render: (text) => {
        return text || "-";
      },
    },
  ];

  const appraisalcolumns = [
    {
      title: "Sl.no",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Target for the upcoming appraisal period",
      dataIndex: "targetobjectives",
      key: "targetobjectives",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
    },
    {
      title: "Target Date",
      dataIndex: "targetdate",
      key: "targetdate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {text}
        </>
      ),
    },
    {
      title: "Remedial Actions to be taken",
      dataIndex: "remedialactions",
      key: "remedialactions",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "actionoxpectedoutcomes",
      key: "actionoxpectedoutcomes",
    },
    {
      title: "Target Date",
      dataIndex: "targetdate",
      key: "targetdate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {text}
        </>
      ),
    },
  ];

  const getIndividualAssessmentData = (segment) => {
    const segmentData = filteredData?.individualassessment?.[segment];
    return [
      {
        label: "Client Survey Average Score",
        value: segmentData?.clientsurveyscore,
      },
      {
        label: "VTP Appraisal Average Score",
        value: segmentData?.vtpappraisalscore,
      },
      {
        label: "LMS – 40 hrs (target to actual %)",
        value: segmentData?.lmstarget,
      },
      { label: "Non–Chargeable %", value: segmentData?.nonchargeable },
      {
        label: "No. of Credentials Inputted",
        value: segmentData?.noofcredentialsinputted,
      },
      {
        label: "Avg Time-sheet approval delays in days",
        value: segmentData?.avgtimesheetapprovedelaydays,
      },
      {
        label: "No. of assignments worked on",
        value: segmentData?.noofassignmentsworked,
      },
      { label: "Employee Profit/Loss", value: segmentData?.employeeprofitloss },
      { label: "No. of leads Created", value: segmentData?.noofleads },
      {
        label: "Engagement Appraisal Average Score",
        value: segmentData?.engagementappraisalscore,
      },
      { label: "Leaves Taken (Days)", value: segmentData?.leavetakendays },
      {
        label: "Chargeability (Target to Actual %)",
        value: segmentData?.chargeability,
      },
      {
        label: "CV Last Updated (Date)",
        value: moment(segmentData?.cvlastupdateddate).format("Do MMM YYYY"),
      },
      {
        label: "Avg Time-sheet delays in days",
        value: segmentData?.avgtimesheetdelaydays,
      },
      {
        label: "Average Task Delays in Days (VTP)",
        value: segmentData?.avgtaskdelaydays,
      },
      { label: "Employee Billing", value: segmentData?.employeebilling },
      {
        label: "Amounts of Proposal in the pipeline",
        value: segmentData?.amountsofproposal,
      },
      {
        label: "Proposal Conversion Rates(%)",
        value: segmentData?.proposalconversionrate,
      },
    ];
  };
  const individualAssessmentData = getIndividualAssessmentData(selectedSegment);

  const getTableData = (segment) => {
    const segmentData = filteredData?.clusterlevel?.[segment];
    return [
      {
        label: "Revenue, Rev vs budget, and GOLY%",
        value: segmentData?.revenuerevvsbudgetandgoly,
      },
      {
        label: "Rev/ Profit per employee",
        value: segmentData?.revprofitperemployee,
      },
      {
        label: "Debtors in USD and days",
        value: segmentData?.debotorsinusdanddays,
      },
      {
        label: "Employee cost, Profits as a %age of rev",
        value: segmentData?.employeecostprofitsasageofrev,
      },
      {
        label: "Departmental Profit, vs budget, GOLY %",
        value: segmentData?.departmentalprofitvsbudgetgoly,
      },
    ];
  };
  const tableData = getTableData(selectedSegment);

  let reviewedAppraiser = Object.keys(filteredData?.reviewedby).find(
    (key) => key === selectedSegment
  );
  let reviewedDate = Object.keys(filteredData?.reviewedon).find(
    (key) => key === selectedSegment
  );
  let comment = Object.keys(filteredData?.individualassessment).find(
    (key) => key === selectedSegment
  );
  let matrixtechnicalassessmentValue = Object.keys(
    filteredData?.reviewtechnicalassessment
  ).find((key) => key === selectedSegment);
  let matrixbdoValue = Object.keys(filteredData?.bdovalues).find(
    (key) => key === selectedSegment
  );

  let reviewedAppraiserMailid = filteredData?.reviewedby[reviewedAppraiser];
  let acceptDate = filteredData?.reviewedon[reviewedDate];
  let appraiseeComment = filteredData?.individualassessment[comment];
  let reviewmatrixtechnicalassessmentValue =
    filteredData?.reviewtechnicalassessment[matrixtechnicalassessmentValue];
  let reviewmatrixbdoValue = filteredData?.bdovalues[matrixbdoValue];

  const sumAppraiserScores = reviewmatrixtechnicalassessmentValue.reduce(
    (sum, item) => sum + item.appraiserscore * parseFloat(item.weightage),
    0
  );

  const sumBdoScores = reviewmatrixbdoValue.reduce(
    (sum, item) => sum + item.appraiserscore * parseFloat(item.weightage),
    0
  );

  const acceptAppraiser = userList?.find(
    (item) => item?.userid === reviewedAppraiserMailid
  );

  return (
    <Customstyle>
      <SegmentWrap
        options={appraisalInformation?.map((item, index) => ({
          label: (
            <div style={{ display: "flex", alignItems: "center" }}>
              {item.roletype}
            </div>
          ),
          value: item.roletype,
        }))}
        value={selectedSegment}
        onChange={(value) => {
          handleSegmentChange(value);
        }}
      />
      <h6>
        <span
          className="title"
          onClick={() => history.push("/performancemanagement")}
        >
          Performance Management{" "}
        </span>{" "}
        <span>&gt;</span>
        {filteredData?.performancecontractname || "-"}
      </h6>
      <br />
      <h5>Appraisal Review</h5>
      <br />
      <h6>Individual Assessment</h6>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          {individualAssessmentData.slice(0, 9).map((item, index) => (
            <div key={index} className="rows pt-2 pb-2">
              <div className="col-label">{item.label}</div>
              <div className="col-value">{item.value}</div>
            </div>
          ))}
        </Col>
        <Col xs={24} md={12}>
          {individualAssessmentData.slice(9).map((item, index) => (
            <div key={index} className="rows pt-2 pb-2">
              <div className="col-label">{item.label}</div>
              <div className="col-value">{item.value}</div>
            </div>
          ))}
        </Col>
      </Row>
      <br />
      <br />
      <h6>Departmental/Country/Cluster level assessment</h6>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          {tableData.slice(0, 3).map((item, index) => (
            <div key={index} className="rows pt-2 pb-2">
              <div className="col-label">{item.label}</div>
              <div className="col-value">{item.value}</div>
            </div>
          ))}
        </Col>

        <Col xs={24} md={12}>
          {tableData.slice(3).map((item, index) => (
            <div key={index} className="rows pt-2 pb-2">
              <div className="col-label">{item.label}</div>
              <div className="col-value">{item.value}</div>
            </div>
          ))}
        </Col>
      </Row>
      <br />
      <br />
      <h6>Technical Assessment</h6>
      <StyledTable
        columns={columns}
        dataSource={filteredData?.reviewtechnicalassessment?.[selectedSegment]}
        className="custom-table"
        size="middle"
        pagination={false}
        //loading={loading}
      />
      <div className="parent-container">
        <div className="averagescore">
          <p>
            Appraiser’s Average Score:{" "}
            <span className="score">{sumAppraiserScores / 100 || "-"}</span>
          </p>
        </div>
      </div>
      <br />
      <br />
      <h6>Individual (Soft Skills) Assessment / BDO Values</h6>
      <StyledTable
        columns={columns1}
        dataSource={filteredData?.bdovalues?.[selectedSegment]}
        className="custom-table"
        size="middle"
        pagination={false}
        //loading={loading}
      />
      <div className="parent-container">
        <div className="averagescore">
          <p>
            Appraiser’s Average Score:{" "}
            <span className="score">{sumBdoScores / 100 || "-"}</span>
          </p>
        </div>
      </div>
      <br />
      <PerformanceMatrix
        Xaxis={sumBdoScores / 100}
        Yaxis={sumAppraiserScores / 100}
      />
      <br />
      <br />
      <br />
      <br />
      <h6>Recommendations for the next appraisal period</h6>
      <p className="recommendtext">
        Strategic Objectives, actions, training or other developmental
        activities to be undertaken by Appraisee during the next period.
      </p>
      <StyledTable
        columns={appraisalcolumns}
        dataSource={
          filteredData?.reviewupcomingappraisalperiod?.[selectedSegment]
        }
        pagination={false}
      />
      <br /> <br /> <br />
      <h6>Overall Rating / Comments</h6>
      <br />
      <div className="appraiser">
        <div>
          <p className="recommendtext">
            Appraiser Name
            <span className="count">
              &nbsp;&nbsp;&nbsp;&nbsp;{acceptAppraiser.fullname || "-"}
            </span>
          </p>
        </div>
        <div>
          <p className="recommendtext">
            Accept Date
            <span className="count">
              &nbsp;&nbsp;&nbsp;&nbsp;
              {acceptDate
                ? moment(acceptDate).format("Do MMM, YYYY") // e.g., 1st Jan 2025
                : "N/A" || "-"}
            </span>
          </p>
        </div>
      </div>
      <p className="recommendtext">Appraisee’s Comment</p>
      <p className="final">{appraiseeComment.overallsummary || "-"}</p>
      <br />
      <p className="recommendtext">Appraiser’s Comment</p>
      <p className="final">
        {filteredData?.successionplanning?.[selectedSegment]
          ?.appraisercomment || "-"}
      </p>
      <br />
      <br />
      <br />
      {/* <div className='footer'>
                <Button className='footer-button' type="primary" onClick={() => history.push("/performancemanagement")}>Back</Button>
            </div> */}
    </Customstyle>
  );
}
const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps)(Viewcompleted);
